import moment from "moment";
import { fetchData } from "../helpers/fetchData";
import Axios from "./axios";
import { transformManageCosts } from "../utils/transformManageCosts";
import { isLowStockItem, isOutOfStockItem } from "../utils/StockAlerts";

export const getPractionerAndPatientsList = async (
  setFieldsLoading,
  setPractionersList,
  setPatientsList,
) => {
  setFieldsLoading(true);
  const [practitionerResponse, patientResponse] = await Promise.all([
    fetchData("POST", "/v3/practitioner/get", {}),
    fetchData("POST", "/v3/patient/getList", {}),
  ]);
  setFieldsLoading(false);
  practitionerResponse?.data
    ? setPractionersList(practitionerResponse?.data)
    : setPractionersList([]);
  patientResponse?.data
    ? setPatientsList(patientResponse?.data)
    : setPatientsList([]);
};

export const getPractionerAndAppointmentTypes = async (
  setFieldsLoading,
  setPractionersList,
  setAppointmentTypes,
) => {
  setFieldsLoading(true);
  const [practitionerResponse, appointmentTypesResponse] = await Promise.all([
    fetchData("POST", "/v3/practitioner/get", {}),
    fetchData("POST", "/v3/appointmentTypes/list", {}),
  ]);
  setFieldsLoading(false);
  practitionerResponse?.data
    ? setPractionersList(practitionerResponse?.data)
    : setPractionersList([]);
  appointmentTypesResponse?.data
    ? setAppointmentTypes(appointmentTypesResponse?.data)
    : setAppointmentTypes([]);
};

export const getPractionerBySpeciality = async (
  setFieldsLoading,
  setPractionersList,
  speciality_id,
) => {
  setFieldsLoading(true);
  const practitionerResponse = await fetchData(
    "POST",
    "/v3/practitioner/getBySpeciality",
    {
      speciality_id: speciality_id,
    },
  );
  setFieldsLoading(false);
  practitionerResponse?.data
    ? setPractionersList(practitionerResponse?.data)
    : setPractionersList([]);
};
export const getRouteAndFrequencyData = async (
  setFieldsLoading,
  setFrequencyList,
  setRoutesList,
  isHaveFrequencyPermission,
  isHaveRoutesPermission,
) => {
  setFieldsLoading(true);

  const apiCalls = [];
  if (isHaveFrequencyPermission) {
    apiCalls.push(fetchData("POST", "/v3/frequency/getList", {}));
  } else {
    setFrequencyList([]);
  }

  if (isHaveRoutesPermission) {
    apiCalls.push(fetchData("POST", "/v3/route/getList", {}));
  } else {
    setRoutesList([]);
  }

  const responses = await Promise.all(apiCalls);
  setFieldsLoading(false);

  let responseIndex = 0;
  if (isHaveFrequencyPermission) {
    const frequencyResponse = responses[responseIndex++];
    setFrequencyList(frequencyResponse?.data || []);
  }

  if (isHaveRoutesPermission) {
    const routesResponse = responses[responseIndex];
    setRoutesList(routesResponse?.data || []);
  }
};

export const getPractitionerList = async (
  setFieldsLoading,
  setPractionersList,
) => {
  setFieldsLoading(true);
  const response = await fetchData("POST", "/v3/practitioner/get", {});
  setFieldsLoading(false);
  response?.data ? setPractionersList(response?.data) : setPractionersList([]);
};
export const getDepartmentList = async (
  setFieldsLoading,
  setDepartmentList,
) => {
  setFieldsLoading(true);
  const response = await fetchData("POST", "/v3/department/getList", {
    page: 1,
    per_page: 1000,
  });
  setFieldsLoading(false);
  response?.data ? setDepartmentList(response?.data) : setDepartmentList([]);
};
export const getLimitedPractitionerList = async (
  setFieldsLoading,
  setPractionersList,
) => {
  setFieldsLoading(true);
  const response = await fetchData(
    "POST",
    "/v3/practitioner/getLimitedData",
    {},
  );
  setFieldsLoading(false);
  response?.data ? setPractionersList(response?.data) : setPractionersList([]);
};
export const getPractitionerDepartmentList = async (
  setIsLoading,
  setListData,
) => {
  setIsLoading(true);
  const response = await fetchData(
    "POST",
    "/v3/practitioner/getByDepartment",
    {},
  );
  setIsLoading(false);
  if (setListData) {
    response?.data ? setListData(response?.data) : setListData([]);
  }
  return response?.data;
};

export const getNursesAndDriversData = async (
  setIsLoading,
  setNursesData,
  setDriversData,
  isHaveDriverPermission,
  isHaveNursePermission,
) => {
  setIsLoading(true);
  const requests = [];
  if (isHaveNursePermission) {
    requests.push(fetchData("POST", "/v3/nurse/get", {}));
  } else {
    setNursesData([]);
  }

  if (isHaveDriverPermission) {
    requests.push(fetchData("POST", "/v3/driver/get", {}));
  } else {
    setDriversData([]);
  }
  const [nursesReponse, driversResponse] = await Promise.all(requests);

  setIsLoading(false);

  if (isHaveNursePermission) {
    nursesReponse?.data
      ? setNursesData(nursesReponse?.data)
      : setNursesData([]);
  }

  if (isHaveDriverPermission) {
    driversResponse?.data
      ? setDriversData(
        driversResponse?.data?.map((driver) => ({
          ...driver,
          assigned_nurses: [],
        })),
      )
      : setDriversData([]);
  }
};

export const handleCheckPatientElibility = async (
  payload,
  setOpenEligibilityForm = () => { },
  setEligibilityResData = () => { },
) => {
  const currentDate = moment().format("YYYY-MM-DD");
  const checkEligibilityPayload = {
    start_date: currentDate,
    end_date: payload?.end_date || currentDate,
    payer_id: payload?.payer_id || "",
    patient_id: payload?.rcm_ref,
    insurance_plan_id: payload?.insurance_plan_id || "",
    purpose:
      payload?.is_new_born || payload?.is_referral
        ? ["benefits", "validation"]
        : ["benefits", "validation", "discovery"],
    is_new_born: payload?.is_new_born || false,
    is_referral: payload?.is_referral || false,
  };
  let response = await fetchData(
    "POST",
    "/v3/RCM/sendVerification",
    checkEligibilityPayload,
  );
  if (response) {
    setEligibilityResData(response);
    setOpenEligibilityForm(true);
  }
  // if (
  //   response?.nphies_status == "error" &&
  //   response?.message !== "data sent to payer"
  // ) {
  //   toast.error(response?.message);
  // } else {
  //   if (response) {
  //     toast.success(response?.message);
  //   }
  // }
  if (response?.status === 200) {
    return response;
  }
};

// export const getPriceListByPractitionerId = async (
//   payload,
//   selectedPayerData,
//   selectedPatientData,
//   i18n,
//   followUp,
//   payer
// ) => {
//   let response = await fetchData(
//     "POST",
//     "/v3/pricelists/getByPractitionerId",
//     payload
//   );
//   if (response?.data && response?.data?.length) {
//     let formattedItems = response?.data?.map((itemData) => {
//       let selectedPatientPayerId =
//         selectedPatientData?.beneficiary_type == "cash"
//           ? selectedPayerData?.payer_id
//           : selectedPayerData?.his_payer_id;
//       // let selectedItemPayer = itemData?.payer_details?.find(
//       //   data => data?.payer_id == selectedPatientPayerId
//       // )
//       let selectedItemPayer = itemData?.payer_details?.[0];
//       const isMasterPrice = selectedItemPayer?.payer?.is_master_price;

//       return {
//         item_name: selectedItemPayer ? selectedItemPayer?.non_standard_description : itemData?.non_standard_description || "",
//         item_id: itemData?.id,
//         item_type: itemData?.price_list_type?.name_en,
//         internal_pharmacy: itemData?.internal_pharmacy,
//         standard_code: itemData?.standard_code,
//         selected_category: itemData?.price_list_type?.category || "",
//         standard_description: itemData?.standard_description,
//         master_code: itemData?.non_standard_code,
//         non_standard_code:
//           itemData?.non_standard_code ||
//           selectedItemPayer?.agreed_code ||
//           selectedItemPayer?.non_standard_code ||
//           "",
//         non_standard_description:
//           itemData?.non_standard_description ||
//           selectedItemPayer?.agreed_description_en ||
//           selectedItemPayer?.non_standard_description ||
//           "",
//         non_standard_description_ar:
//           itemData?.non_standard_description_ar ||
//           selectedItemPayer?.agreed_description_ar ||
//           selectedItemPayer?.non_standard_description_ar ||
//           "",
//         is_package: "false",
//         quantity: 1,
//         total_quantity: 1,
//         unit_price:
//           followUp === "Follow Up"
//             ? 0
//             : selectedItemPayer ? isMasterPrice
//               ? itemData?.master_price
//               : selectedItemPayer?.payer_price : itemData?.payer_price || 0,

//         item_category: selectedItemPayer ? selectedItemPayer?.payer?.category : payer?.category || "",
//         is_approval: selectedItemPayer?.is_approval || false,
//         ...(selectedItemPayer?.is_approval
//           ? selectedItemPayer?.payer?.category === "insurance"
//             ? {
//               approved_qty: 1,
//               approved_amount:
//                 followUp === "Follow Up"
//                   ? 0
//                   : isMasterPrice
//                     ? itemData?.master_price
//                     : selectedItemPayer?.payer_price,
//               approval_status: "pending",
//             }
//             : {
//               approved_qty: 1,
//               approved_amount:
//                 followUp === "Follow Up"
//                   ? 0
//                   : selectedItemPayer ? isMasterPrice
//                     ? itemData?.master_price
//                     : selectedItemPayer?.payer_price : itemData?.payer_price || 0,
//               approval_status: "approved",
//             }
//           : null),
//         tax_amount: 0,
//         factor: 0,
//         net: 0,
//         discount_amount: selectedItemPayer ? selectedItemPayer?.discount_percentage : itemData?.discount_percentage || 0,
//         discount_type: "percentage",
//         patient_share:
//           selectedItemPayer ? selectedItemPayer?.payer?.category : payer?.category || "" === "cash"
//             ? 100
//             : selectedPayerData?.patient_share || 20,
//         patientShareAmount: 0,
//         payer_share: "",
//         payer_id: selectedItemPayer ? selectedItemPayer?.payer_id : payer?.payer_id || "",
//         days_supply: 0,
//         checked: true,
//         invoice_no: 0,
//         company_invoice_no: 0,
//         tax_check:
//           itemData?.apply_vat == false ||
//             selectedPatientData?.document_id?.startsWith("1")
//             ? false
//             : true,
//         order_changeable_price: itemData?.order_changeable_price,
//       };
//     });
//     return formattedItems;
//   }
// };

export const getPriceListByPractitionerId = async (
  payload,
  selectedPayerData,
  selectedPatientData,
  i18n,
  followUp,
  isMaster,
  payer,
  isVatApplicable = false,
) => {
  let response = await fetchData(
    "POST",
    "/v3/pricelists/getByPractitionerId",
    payload,
  );

  if (!(response?.data && response?.data?.length)) return [];
  const formattedItems = response.data.map((itemData) => {
    // const selectedItemPayer = itemData?.payer_details?.find((data)=>(data?.payer_id==selectedPayerData?.his_payer_id));
    const selectedItemPayer = itemData?.payer_details?.[0];
    const isFollowUp = followUp === "Follow Up";
    // const isMasterPrice = selectedItemPayer?.payer?.is_master_price;
    const isMasterPrice = isMaster;
    const selectedServiceDiscount =
      selectedItemPayer?.payer?.service_discount?.find(
        (item) => item?.service_id === itemData?.price_list_type?.id,
      );

    const number_of_sessions = itemData?.session
      ? itemData?.number_of_sessions
      : 0;
    const basePrice = isMasterPrice
      ? itemData?.master_price
      : (selectedItemPayer?.payer_price ?? 0);

    const unitPrice = (
      isFollowUp
        ? 0
        : number_of_sessions
          ? basePrice / number_of_sessions
          : basePrice || 0
    ).toFixed(2);

    const patientCategory =
      selectedItemPayer?.payer?.category || payer?.category || "";

    const patientShare =
      patientCategory === "cash"
        ? 100
        : selectedServiceDiscount?.patient_share ||
        selectedPayerData?.patient_share ||
        20;
    const isOutOfStock = isOutOfStockItem(itemData);
    const isLowStock =
      !isOutOfStock && (itemData?.low_stock || isLowStockItem(itemData));

    return {
      low_stock: isLowStock,
      out_of_stock: isOutOfStock,
      is_stock: itemData?.is_stock,
      stock: itemData?.stock,
      item_name:
        selectedItemPayer?.non_standard_description ||
        itemData?.non_standard_description ||
        "",

      item_id: itemData?.id,
      item_type: itemData?.price_list_type?.name_en,
      daily_package_deal: itemData?.daily_package_deal,
      internal_pharmacy: itemData?.internal_pharmacy,
      number_of_sessions: number_of_sessions,
      is_consumable:
        itemData?.is_consumable !== undefined
          ? itemData?.is_consumable
          : itemData?.consumable || false,
      original_price: isFollowUp ? 0 : basePrice || 0,
      standard_code: itemData?.standard_code,
      selected_category: itemData?.price_list_type?.category || "",
      standard_description: itemData?.standard_description,
      master_code: itemData?.non_standard_code,
      supergit_master_code:
        itemData?.source === "sfda" || itemData?.source === "provider_pharmacy"
          ? itemData?.supergit_master_code || itemData?.non_standard_code
          : itemData?.supergit_master_code || null,
      manage_costs: transformManageCosts(itemData?.manage_costs),
      non_standard_code:
        itemData?.non_standard_code ||
        selectedItemPayer?.agreed_code ||
        selectedItemPayer?.non_standard_code ||
        "",
      non_standard_description:
        itemData?.non_standard_description ||
        selectedItemPayer?.agreed_description_en ||
        selectedItemPayer?.non_standard_description ||
        "",
      non_standard_description_ar:
        itemData?.non_standard_description_ar ||
        selectedItemPayer?.agreed_description_ar ||
        selectedItemPayer?.non_standard_description_ar ||
        "",
      payer_vat: isMasterPrice
        ? isVatApplicable === true
        : selectedItemPayer?.payer?.is_vat_applicable === true,
      is_package: "false",
      quantity: 1,
      total_quantity: 1,
      unit_price: isFollowUp ? 0 : unitPrice,

      item_category: patientCategory,
      is_approval: selectedItemPayer?.is_approval || false,

      ...(selectedItemPayer?.is_approval
        ? patientCategory === "insurance"
          ? {
            approved_qty: 1,
            approved_amount: isFollowUp ? 0 : unitPrice,
            approval_status: "pending",
          }
          : {
            approved_qty: 1,
            approved_amount: isFollowUp ? 0 : unitPrice,
            approval_status: "approved",
          }
        : {}),

      tax_amount: 0,
      factor: 0,
      net: 0,

      discount_amount:
        selectedServiceDiscount?.patient_discount ||
        selectedItemPayer?.payer?.generals?.discount ||
        selectedItemPayer?.discount_percentage ||
        itemData?.discount_percentage ||
        0,

      discount_type: "percentage",

      patient_share: patientShare,
      patientShareAmount: 0,

      payer_share: "",
      payer_id: selectedItemPayer?.payer_id || payer?.payer_id || "",

      selected_category: itemData?.price_list_type?.category || "",
      days_supply: 0,
      checked: true,
      invoice_no: 0,
      company_invoice_no: 0,

      tax_check:
        itemData?.apply_vat === false ||
          selectedPatientData?.nationality?.toLowerCase() === "saudi"
          ? false
          : true,

      order_changeable_price: itemData?.order_changeable_price,
    };
  });

  return formattedItems.filter(Boolean);
};

export const getStaffDataByUserId = async (userId) => {
  let response = await fetchData("POST", "/v3/staff/getByUserId", {
    user_id: userId,
  });
  return response?.data;
};

export const getItemWiseReportSummary = async (payload) => {
  const response = await fetchData(
    "POST",
    "/v3/reports/items/itemwisereportsummary",
    payload,
  );
  return response?.data || response;
};

export const getItemWiseReportDetails = async (payload) => {
  const response = await fetchData(
    "POST",
    "/v3/reports/items/itemwisereportdetails",
    payload,
  );
  return response?.data || response;
};

export const getAppointmentItems = async (
  appointment_id,
  selectedPayerData,
  selectedPatientData,
  followUp,
  payer,
) => {
  if (!appointment_id) return { success: false, items: [] };

  try {
    const response = await fetchData("POST", "/v3/appointments/getItems", {
      appointment_id,
      payer_id:
        selectedPayerData?.his_payer_id ||
        selectedPayerData?.payer_id ||
        selectedPayerData?.id,
    });

    if (
      !(
        response?.data &&
        Array.isArray(response.data) &&
        response.data.length > 0
      )
    ) {
      return { success: false, items: [], shouldFallback: true };
    }

    const formattedItems = response.data.map((itemData) => {
      const selectedItemPayer = itemData?.payer_details?.[0];
      const isFollowUp = followUp === "Follow Up";
      const isMasterPrice = selectedItemPayer?.payer?.is_master_price;
      const selectedServiceDiscount =
        selectedItemPayer?.payer?.service_discount?.find(
          (item) => item?.service_id === itemData?.price_list_type?.id,
        );

      const number_of_sessions = itemData?.session
        ? itemData?.number_of_sessions
        : 0;
      const basePrice = isMasterPrice
        ? itemData?.master_price
        : (selectedItemPayer?.payer_price ?? 0);

      const unitPrice = (
        isFollowUp
          ? 0
          : number_of_sessions
            ? basePrice / number_of_sessions
            : basePrice || 0
      ).toFixed(2);

      const patientCategory =
        selectedItemPayer?.payer?.category || payer?.category || "";

      const patientShare =
        patientCategory === "cash"
          ? 100
          : selectedServiceDiscount?.patient_share ||
          selectedPayerData?.patient_share ||
          20;

      return {
        item_name:
          selectedItemPayer?.non_standard_description ||
          itemData?.non_standard_description ||
          "",
        item_id: itemData?.id,
        item_type: itemData?.price_list_type?.name_en,
        daily_package_deal: itemData?.daily_package_deal,
        internal_pharmacy: itemData?.internal_pharmacy,
        number_of_sessions,
        original_price: isFollowUp ? 0 : basePrice || 0,
        standard_code: itemData?.standard_code,
        selected_category: itemData?.price_list_type?.category || "",
        standard_description: itemData?.standard_description,
        master_code: itemData?.non_standard_code,
        supergit_master_code:
          itemData?.source === "sfda" ||
            itemData?.source === "provider_pharmacy"
            ? itemData?.supergit_master_code || itemData?.non_standard_code
            : itemData?.supergit_master_code || null,
        manage_costs: transformManageCosts(itemData?.manage_costs),
        non_standard_code:
          itemData?.non_standard_code ||
          selectedItemPayer?.agreed_code ||
          selectedItemPayer?.non_standard_code ||
          "",
        non_standard_description:
          itemData?.non_standard_description ||
          selectedItemPayer?.agreed_description_en ||
          selectedItemPayer?.non_standard_description ||
          "",
        non_standard_description_ar:
          itemData?.non_standard_description_ar ||
          selectedItemPayer?.agreed_description_ar ||
          selectedItemPayer?.non_standard_description_ar ||
          "",
        payer_vat: selectedItemPayer?.payer?.is_vat_applicable === true,
        is_package: "false",
        quantity: 1,
        total_quantity: 1,
        unit_price: unitPrice,
        item_category: patientCategory,
        is_approval: selectedItemPayer?.is_approval || false,

        ...(selectedItemPayer?.is_approval
          ? patientCategory === "insurance"
            ? {
              approved_qty: 1,
              approved_amount: isFollowUp ? 0 : unitPrice,
              approval_status: "pending",
            }
            : {
              approved_qty: 1,
              approved_amount: isFollowUp ? 0 : unitPrice,
              approval_status: "approved",
            }
          : {}),

        tax_amount: 0,
        factor: 0,
        net: 0,
        discount_amount:
          selectedServiceDiscount?.patient_discount ||
          selectedItemPayer?.payer?.generals?.discount ||
          selectedItemPayer?.discount_percentage ||
          itemData?.discount_percentage ||
          0,
        discount_type: "percentage",
        patient_share: patientShare,
        patientShareAmount: 0,
        payer_share: "",
        payer_id: selectedItemPayer?.payer_id || payer?.payer_id || "",
        days_supply: 0,
        checked: true,
        invoice_no: 0,
        company_invoice_no: 0,
        tax_check:
          itemData?.apply_vat === false ||
            selectedPatientData?.nationality?.toLowerCase() === "saudi"
            ? false
            : true,
        order_changeable_price: itemData?.order_changeable_price,
      };
    });

    return formattedItems;
  } catch (error) {
    console.error("Failed to fetch appointment items:", error);
    return [];
  }
};

export const getPractitionerSlotsRange = async (payload) => {
  try {
    const response = await Axios.post(
      "/v3/visit/getPractitionerSlots",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch practitioner slots range:", error);
    return { available_slots: [], booked_appointments: [] };
  }
};

export const createBulkAppointments = async (payload) => {
  try {
    let response;
    try {
      response = await Axios.post("/v3/appointments/create-bulk", payload);
    } catch (v3Error) {
      if (v3Error.response && v3Error.response.status === 404) {
        response = await Axios.post("/v1/appointments/create-bulk", payload);
      } else {
        throw v3Error;
      }
    }
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    if (error.response && error.response.data) {
      return {
        status: error.response.status,
        data: error.response.data,
        error:
          error.response.data?.message || "Bulk appointment creation failed",
      };
    }
    throw error;
  }
};
